import { useNavigate } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTableContext } from '../../../../context/table-context';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

function DashboardAdvancesOffers({ fundingSummary, activeOffers, dwollaBalance }) {
  const navigate = useNavigate();

  const { clearTableFilters, setSelectedFundingIdsFilter } = useTableContext();

  const onItemCountClick = (fundingIds, message) => {
    clearTableFilters({
      tableName: 'fundings',
      initSortBy: 'id',
      initSortOrder: 'desc',
      initRowsPerPage: 25,
    });
    setSelectedFundingIdsFilter({ fundingIds: fundingIds.join(','), message });
    navigate('/fundings');
  };

  return (
    <Card className="mb-0">
      <Card.Header className="d-flex justify-content-between">Advances</Card.Header>
      {fundingSummary && activeOffers ? (
        <>
          <Card.Body>
            <div className="d-flex justify-content-center flex-wrap">
              <div className="bo-border-container rounded m-1 bo-min-w-200">
                <p className="text-capitalize bo-badge">Advances to date</p>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="text-center h5">{`$${fundingSummary.AdvancesToDate_sum}`}</p>
                  <p className="text-center h6">{`(${fundingSummary.AdvancesToDate_count})`}</p>
                </div>
              </div>
              <div className="bo-border-container rounded m-1 bo-min-w-200">
                <p className="text-capitalize bo-badge">Open Advances</p>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="text-center h5">{`$${fundingSummary.AdvancesOpen_sum}`}</p>
                  {fundingSummary.AdvancesOpen_list.length > 0 ? (
                    <Button
                      className="bo-button-inline-link p-0 d-flex"
                      onClick={() =>
                        onItemCountClick(
                          fundingSummary.AdvancesOpen_list,
                          'Dashboard → Advances → Open Advances',
                        )
                      }
                    >
                      <p className="text-center h6">{`(${fundingSummary.AdvancesOpen_count})`}</p>
                      <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="mt-1 ms-1" />
                    </Button>
                  ) : (
                    <p className="text-center h6">{`(${fundingSummary.AdvancesOpen_count})`}</p>
                  )}
                </div>
              </div>
              <div className="bo-border-container rounded m-1 bo-min-w-200">
                <p className="text-capitalize bo-badge">Default Advances</p>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="text-center h5">{`$${fundingSummary.AdvancesDefault_sum}`}</p>
                  {fundingSummary.AdvancesDefault_list.length > 0 ? (
                    <Button
                      className="bo-button-inline-link p-0 d-flex"
                      onClick={() =>
                        onItemCountClick(
                          fundingSummary.AdvancesDefault_list,
                          'Dashboard → Advances → Default Advances',
                        )
                      }
                    >
                      <p className="text-center h6">
                        {`(${fundingSummary.AdvancesDefault_count})`}
                      </p>
                      <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="mt-1 ms-1" />
                    </Button>
                  ) : (
                    <p className="text-center h6">{`(${fundingSummary.AdvancesDefault_count})`}</p>
                  )}
                </div>
              </div>
              <div className="bo-border-container rounded m-1 bo-min-w-200">
                <p className="text-capitalize bo-badge">Fees to Date</p>
                <div className="d-flex align-items-center justify-content-center">
                  <p className="text-center h5">{`$${fundingSummary.TransferFees_sum}`}</p>
                </div>
              </div>
            </div>
          </Card.Body>
          <Card.Header className="border-0">Advances Aging</Card.Header>
          <Card.Body>
            <div className="d-flex justify-content-center flex-wrap">
              <div className="bo-border-container rounded m-1 bo-w-500">
                {fundingSummary.agingData?.map(x => (
                  <div
                    key={x.description}
                    className="d-flex align-items-center justify-content-between"
                  >
                    <p className="text-start h6 me-3">{x.description}</p>
                    {x.count !== null &&
                    x.count !== undefined &&
                    !!fundingSummary.AdvancesOpen_count ? (
                      <div className="d-flex align-items-center">
                        {x.amount > 0 ? (
                          <Button
                            className="bo-button-inline-link p-0 me-1 d-flex bo-w-100 text-start"
                            onClick={() =>
                              onItemCountClick(x.list, `Dashboard → Aging → ${x.description}`)
                            }
                          >
                            <p className="h6">{`$${x.amount}`}</p>
                          </Button>
                        ) : (
                          <p className="h6 me-1 bo-w-100 text-start">{`$${x.amount}`}</p>
                        )}
                        <span className="bo-text-sm mb-2 bo-w-100">
                          ({x.count}/{fundingSummary.AdvancesOpen_count})
                        </span>
                      </div>
                    ) : (
                      <p className="h6">N/A</p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </Card.Body>
          <Card.Header className="border-0">ACH Payments</Card.Header>
          <Card.Body>
            <div className="d-flex justify-content-center flex-wrap">
              <div className="bo-border-container rounded m-1 bo-min-w-200">
                <p className="text-capitalize bo-badge">Pending - Out</p>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="text-center h5">{`$${fundingSummary.TransferPendingOut_sum}`}</p>
                  {fundingSummary.TransferPendingOut_list.length > 0 ? (
                    <Button
                      className="bo-button-inline-link p-0 d-flex"
                      onClick={() =>
                        onItemCountClick(
                          fundingSummary.TransferPendingOut_list,
                          'Dashboard → ACH → Pending Out',
                        )
                      }
                    >
                      <p className="text-center h6">
                        {`(${fundingSummary.TransferPendingOut_count})`}
                      </p>
                      <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="mt-1 ms-1" />
                    </Button>
                  ) : (
                    <p className="text-center h6">
                      {`(${fundingSummary.TransferPendingOut_count})`}
                    </p>
                  )}
                </div>
              </div>
              <div className="bo-border-container rounded m-1 bo-min-w-200">
                <p className="text-capitalize bo-badge">Pending - In</p>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="text-center h5">{`$${fundingSummary.TransferPendingIn_sum}`}</p>
                  {fundingSummary.TransferPendingIn_list.length > 0 ? (
                    <Button
                      className="bo-button-inline-link p-0 d-flex"
                      onClick={() =>
                        onItemCountClick(
                          fundingSummary.TransferPendingIn_list,
                          'Dashboard → ACH → Pending In',
                        )
                      }
                    >
                      <p className="text-center h6">
                        {`(${fundingSummary.TransferPendingIn_count})`}
                      </p>
                      <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="mt-1 ms-1" />
                    </Button>
                  ) : (
                    <p className="text-center h6">
                      {`(${fundingSummary.TransferPendingIn_count})`}
                    </p>
                  )}
                </div>
              </div>
              <div className="bo-border-container rounded m-1 bo-min-w-200">
                <p className="text-capitalize bo-badge">Debit Return Rate</p>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="text-center h6 me-3">{fundingSummary.CurrentMonth}</p>
                  <p className="text-center h6">
                    {fundingSummary.TransferFailuresCurrentMonth}{' '}
                    <span className="bo-text-sm mb-2">
                      ({fundingSummary.TransferCurrentMonth_failed_cnt}/
                      {fundingSummary.TransferCurrentMonth_all_count})
                    </span>
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="text-center m-0 me-3">
                    <small>{fundingSummary.PreviousMonth}</small>
                  </p>
                  <p className="text-center m-0">
                    <small>
                      {fundingSummary.TransferFailuresPreviousMonth}{' '}
                      <span className="bo-text-sm mb-2">
                        ({fundingSummary.TransferPreviousMonth_failed_cnt}/
                        {fundingSummary.TransferPreviousMonth_all_count})
                      </span>
                    </small>
                  </p>
                </div>
              </div>
              {dwollaBalance && (
                <div className="bo-border-container rounded m-1 bo-min-w-200">
                  <p className="text-capitalize bo-badge">Dwolla Balance</p>
                  <div className="d-flex align-items-center justify-content-center">
                    <p className="text-center h5">{`$${Number(dwollaBalance.balance).toLocaleString(
                      'en-US',
                    )}`}</p>
                  </div>
                </div>
              )}
            </div>
          </Card.Body>
          <Card.Header className="border-0">CARD Payments</Card.Header>
          <Card.Body>
            <div className="d-flex justify-content-center flex-wrap">
              <div className="bo-border-container rounded m-1 bo-min-w-200">
                <p className="text-capitalize bo-badge">Pending - In</p>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="text-center h5">
                    {`$${fundingSummary.CardTransfersPendingIn_sum}`}
                  </p>
                  {fundingSummary.CardTransfersPendingIn_list.length > 0 ? (
                    <Button
                      className="bo-button-inline-link p-0 d-flex"
                      onClick={() =>
                        onItemCountClick(
                          fundingSummary.CardTransfersPendingIn_list,
                          'Dashboard → CARD → Pending In',
                        )
                      }
                    >
                      <p className="text-center h6">
                        {`(${fundingSummary.CardTransfersPendingIn_count})`}
                      </p>
                      <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="mt-1 ms-1" />
                    </Button>
                  ) : (
                    <p className="text-center h6">
                      {`(${fundingSummary.CardTransfersPendingIn_count})`}
                    </p>
                  )}
                </div>
              </div>
              <div className="bo-border-container rounded m-1 bo-min-w-200">
                <div className="d-flex align-items-center gap-3">
                  <p className="bo-badge bo-w-200">{`Failures - ${fundingSummary.CurrentMonth}`}</p>
                  <p className="bo-badge bo-min-w-100 text-nowrap">Transfers</p>
                  <p className="bo-badge bo-min-w-100 text-nowrap">Consumers</p>
                </div>
                {fundingSummary.CurrentMonthCardFailures &&
                Object.entries(fundingSummary.CurrentMonthCardFailures).length > 0 ? (
                  <>
                    {Object.entries(fundingSummary.CurrentMonthCardFailures).map(([key, value]) => (
                      <div key={key} className="d-flex align-items-center gap-3">
                        <p className="h6 bo-w-200">{key}</p>
                        <p className="h6 bo-min-w-100 text-nowrap">
                          {`${Number(
                            (value / fundingSummary.CurrentMonthCardTransfers) * 100,
                          ).toLocaleString('en-US', { maximumFractionDigits: 1 })}%`}
                          <span className="bo-text-sm mb-2">
                            ({value}/{fundingSummary.CurrentMonthCardTransfers})
                          </span>
                        </p>
                        <p className="h6 bo-min-w-100 text-nowrap">
                          {`${Number(
                            (fundingSummary.CurrentMonthCardFailuresConsumers[key] /
                              fundingSummary.CurrentMonthCardTransfersConsumers) *
                              100,
                          ).toLocaleString('en-US', { maximumFractionDigits: 1 })}%`}
                          <span className="bo-text-sm mb-2">
                            ({fundingSummary.CurrentMonthCardFailuresConsumers[key]}/
                            {fundingSummary.CurrentMonthCardTransfersConsumers})
                          </span>
                        </p>
                      </div>
                    ))}
                    <hr className="my-0 mb-2" />
                    <div className="d-flex align-items-center gap-3">
                      <p className="h6 bo-w-200">Total</p>
                      <p className="h6 bo-min-w-100 text-nowrap">
                        {`${Number(
                          (Object.values(fundingSummary.CurrentMonthCardFailures).reduce(
                            (acc, val) => acc + val,
                            0,
                          ) /
                            fundingSummary.CurrentMonthCardTransfers) *
                            100,
                        ).toLocaleString('en-US', { maximumFractionDigits: 1 })}%`}
                        <span className="bo-text-sm mb-2">
                          (
                          {Object.values(fundingSummary.CurrentMonthCardFailures).reduce(
                            (acc, val) => acc + val,
                            0,
                          )}
                          /{fundingSummary.CurrentMonthCardTransfers})
                        </span>
                      </p>
                      <p className="h6 bo-min-w-100 text-nowrap">
                        {`${Number(
                          (fundingSummary.CurrentMonthCardFailuresConsumersTotal /
                            fundingSummary.CurrentMonthCardTransfersConsumers) *
                            100,
                        ).toLocaleString('en-US', { maximumFractionDigits: 1 })}%`}
                        <span className="bo-text-sm mb-2">
                          ({fundingSummary.CurrentMonthCardFailuresConsumersTotal}/
                          {fundingSummary.CurrentMonthCardTransfersConsumers})
                        </span>
                      </p>
                    </div>
                  </>
                ) : (
                  <p className="h6">N/A</p>
                )}
              </div>
            </div>
          </Card.Body>
          <Card.Header className="border-0">Offers</Card.Header>
          <Card.Body>
            <div className="d-flex justify-content-center flex-wrap">
              <div className="bo-border-container rounded m-1 bo-min-w-200">
                <p className="text-capitalize bo-badge">Active Offers</p>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="text-center h5">{`$${activeOffers.sum}`}</p>
                  <p className="text-center h6">{`(${activeOffers.count})`}</p>
                </div>
              </div>
            </div>
          </Card.Body>
        </>
      ) : (
        <Card.Body className="bo-min-h-100" />
      )}
    </Card>
  );
}

export default DashboardAdvancesOffers;
